// @flow

export default (items: number, columns: number): number => {
  if (items < columns) {
    return items;
  }

  const remainder = items % columns;

  if (remainder === 0) {
    return columns;
  }

  const gap = columns - remainder;
  const rows = Math.ceil(items / columns);

  return columns - Math.floor(gap / rows);
};
